import { check } from './roles'

/**
 * Looks for a valid fallback route based on user permission.
 * @param {Array<Object>} routes Array of route objects
 * @param {Array<String>} fallbacks Array of fallback route names
 * @param {Array<Object>} policies Array of current user's policies
 * @returns fallback route path
 */
const routeFallback = (routes, fallbacks, policies, defaultFallback = `/login`) => {
  for (const fallback of fallbacks) {
    const route = routes.find(route => route.path === fallback)
    if (!route?.meta?.restricted || check(policies, route.meta.restricted)) {
      return route.path
    }
  }
  return defaultFallback
}

export { routeFallback }
